import { render, staticRenderFns } from "./myAccount.vue?vue&type=template&id=e634b982&scoped=true"
import script from "./myAccount.vue?vue&type=script&lang=js"
export * from "./myAccount.vue?vue&type=script&lang=js"
import style0 from "./myAccount.vue?vue&type=style&index=0&id=e634b982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e634b982",
  null
  
)

export default component.exports